export const localization = {
  autocomplete: {
    loadingText: "Cargando...",
    noOptionsText: "Sin opciones para seleccionar",
  },
};
